import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getErrorMessage(e: unknown): string {
  if (e && typeof e === 'object') {
    const err = e as Record<string, unknown>
    if (Array.isArray(err.detail) && typeof err.detail[0]?.msg === 'string') {
      return err.detail[0].msg
    }
    if (typeof err.message === 'string') return err.message
  }
  return 'Something went wrong'
}
